// Outcome of a game from the filtered player's point of view — only meaningful
// alongside a username, since "won" is relative to whoever you're looking at.
export enum GameOutcome {
  Won,
  Lost,
}
